import { gql } from '@apollo/client'

export const UNVERIFY_DETECTION = gql`
  mutation UnverifyDetection($imageId: ID!, $feedbackNote: String) {
    unverifyImageDetections(imageId: $imageId, feedbackNote: $feedbackNote) {
      __typename
      ... on VerifyImageDetectionsResult {
        imageId
        success
      }
      ... on OperationInfo {
        messages {
          kind
          message
          field
          code
        }
      }
    }
  }
`
